module.exports = __webpack_public_path__ + "static/media/client-app-logo.5a5515b7.png";